exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1smQS2wL9wylT26TZ_vujF{opacity:0;color:green;vertical-align:top;cursor:pointer;-webkit-transition:opacity .3s ease-out;transition:opacity .3s ease-out}._1smQS2wL9wylT26TZ_vujF:hover{opacity:1}", ""]);

// exports
exports.locals = {
	"addMessage": "_1smQS2wL9wylT26TZ_vujF"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/avatar-uploader.css
 ** module id = 1012
 ** module chunks = 0
 **/